import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import useBreakpoints from '@ui/hooks/useBreakpoints';
import React from 'react';

import useStyles from './HeroAlt.style';

interface CtaButton {
  icon?: React.ReactNode;
  label: string;
  href: string;
  variant: 'contained' | 'outlined';
  color: 'primary' | 'secondary';
  target?: '_blank' | '_self' | '_parent' | '_top';
}
interface HeroAltProps {
  backgroundImage: string;
  title: React.ReactNode;
  subText: React.ReactNode;  
  ctaButtons: CtaButton[];
}

const Hero: React.FC<HeroAltProps> = (props) => {
  const { 
    backgroundImage,
    title,
    subText,
    ctaButtons,
  } = props;

  const { classes, theme } = useStyles();
  const { md } = useBreakpoints();

  const backgroundImageUrl = backgroundImage || '/images/homepage/header.png';
  
  return (
    <div className={classes.heroWrapper}>

      <div className={classes.heroTextContainer}>
        <Typography
          variant="h1"
          className={classes.heroText}
          style={{ marginBottom: theme.spacing(2) }}
        >
          {title}
        </Typography>
        <Typography
          variant="body1"
          className={classes.subText}
        >
          {subText}
        </Typography>

        <Box
          display="flex"
          flexDirection="row"
          justifyContent="flex-start"
          alignItems="center"
          width="100%"
          sx={{
            marginBottom: md ? 0 : '32px',
            '& a': {
              textDecoration: 'none !important'
            }
          }}
        >
          {ctaButtons.map((button) => (
            <a
              key={button.label}
              href={button.href}
              style={{
                display: 'inline-flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontWeight: 'bold',
                backgroundColor: button.color === 'primary' ? '#080808' : '#ffffff',
                color: button.color === 'primary' ? '#ffffff' : '#080808',
                textDecoration: 'none !important',
                borderRadius: '30px',
                padding: md ? '16px 24px' : '12px 16px',
                lineHeight: 1.4,
                height: 'auto',
                marginRight: '16px',
                fontSize: md ? '20px' : '14px',
                border: 0,
              }}
              target={button.target}
              rel={button.target === '_blank' ? 'noopener noreferrer' : undefined}
            >
              {button.icon && (
              <Box sx={{ marginRight: '8px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                {button.icon}
              </Box>
              )}
              {button.label}
            </a>            
          ))}
        </Box>
      </div>

      <div
        className={classes.heroBackground}
        data-bg-multi={`radial-gradient(45.16% 45.16% at 50% 44.87%, rgba(8, 8, 8, 0.05) 0%, rgba(8, 8, 8, 0) 100%), radial-gradient(122.67% 468.02% at 36.8% 60.12%, rgba(8, 8, 8, 0.2) 0%, rgba(8, 8, 8, 0) 100%), url(${backgroundImageUrl})`}
      />
      
      <div className={classes.heroOverlay} />

    </div>
  );
};

export default Hero;
